// 🤖 Assistant Store - habilitar/deshabilitar el asistente virtual (persistido en localStorage)
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AssistantStore {
  enabled: boolean;
  toggle: () => void;
  setEnabled: (value: boolean) => void;
}

export const useAssistantStore = create<AssistantStore>()(
  persist(
    (set, get) => ({
      enabled: true, // visible por defecto
      toggle: () => set({ enabled: !get().enabled }),
      setEnabled: (value: boolean) => set({ enabled: value }),
    }),
    { name: 'assistant-enabled' }
  )
);
